import axios from "axios";
import { API } from "./common/constants";

function getHeader() {
  let head = {
    baseURL: API.API_BASE,
    headers: {},
  };
  return head;
}
const instance = axios.create(getHeader());

instance.interceptors.request.use(function (config) {    
  if (localStorage.user != undefined) {
    if (JSON.parse(localStorage.user).access_token != undefined) {
      config.headers["x-access-token"] = JSON.parse(localStorage.user).access_token;
    }
  }
  return config;
});

export default instance;